import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getFaTransferList } from '@store/Finance/FixedAssets/FaTransfer/FaTransferSlice';
// import { useTranslation } from 'react-i18next';

const useGetFaTransferList = () => {
  const dispatch = useAppDispatch();
  // const { t, i18n } = useTranslation();

  useEffect(() => {
    // if (AssetsList?.length === 0) {
    dispatch(getFaTransferList());
    // }
  }, []);
  const { FaTransferList, loading, error } = useAppSelector(state => state.FaTransfer);

  // var OptionsAssets = RevaluationList?.map(({ id, name, name2 }) => ({
  //   value: id,
  //   label: `${i18n.language === 'en' ? name : name2}`,
  // }));

  return { FaTransferList, loading, error };
};

export default useGetFaTransferList;
